import { doc, getDoc, setDoc } from "firebase/firestore";
import React, { useState } from "react";
import { useEffect } from "react";
import { scribeAuth, scribeDB, signInWithGoogle } from "../../firebaseConfig";
import { REDIRECT_URLS } from "../../config";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { toast } from "react-toastify";

const SignUpPopUp2 = ({ show, onClose }) => {
    // State to capture form inputs
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        date: "",
        email: "",
        password: "",
        confirmPassword: "",
        practiceName: "",
        speciality: "",
    });

    // Close the pop-up when clicking outside of it
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (event.target.id === "popup-overlay") {
                onClose();
            }
        };

        window.addEventListener("click", handleOutsideClick);
        return () => {
            window.removeEventListener("click", handleOutsideClick);
        };
    }, [onClose]);

    if (!show) return null;

    const setUserDoc = async (user) => {
        // setLoading(true);

        try {
            const userDoc = doc(scribeDB, "users", user.uid);
            
            if (getDoc(userDoc)) {
                console.log("User already exists");
                return;
            }
            
            // Set Firestore document
            await setDoc(
                userDoc,
                {
                    email: user.email,
                    onPlan: false,
                    subscriptionStatus: "inactive",
                    sessionCount: 0
                },
                { merge: true } // Merge with existing data
            );
        } catch (error) {
            console.error("Error setting user document => ", error);
            // setError();
        } finally {
            // setLoading(false);
            return;
        }
    }

    const setUserDoc2 = async (user) => {
        try {
            // Update Firestore document
            const userDoc = doc(scribeDB, "users", user.uid);
            await setDoc(
                userDoc,
                {
                    email: user.email,
                    onPlan: false,
                    subscriptionStatus: "inactive",
                    sessionCount: 0,
                    practiceName: formData.practiceName,
                    practiceType: formData.speciality
                },
                { merge: true } // Merge with existing data
            );
        } catch (error) {
            console.error("Error setting user document => ", error);
            // setError();
        } finally {
            // setLoading(false);
            return;
        }
    }

    const handleGoogleSignIn = async () => {
        try {
            const result = await signInWithGoogle();
            const user = result.user;
            // console.log("Signup successful! Welcome, ", user.displayName);
            // console.log("User: " + user);
            // console.log("result: " + result);

            await setUserDoc(user);

            if (1) {
                toast.success("Signup successful!", {
                    className: "font-semibold"
                });

                // console.log("Redirecting...");
    
                // Open a new site in a new tab
                window.open(REDIRECT_URLS.APP_URL, "_blank");
            }
        } catch (err) {
            console.error(err.message);
                
            toast.error("Error signing up...", {
                className: "font-semibold"
            });
        }
    };

    const handleSignUp = async (e) => {
        e.preventDefault();

        try {
//             console.log(`Form data => 
// formData.firstName: ${formData.firstName}
// formData.lastName: ${formData.lastName}
// formData.email: ${formData.email}
// formData.password: ${formData.password}
// formData.confirmPassword: ${formData.confirmPassword}
// ${formData.confirmPassword === formData.password ? "Passwords Match!" : "Passwords DON'T Match!" }
// formData.practiceName: ${formData.practiceName}
// formData.speciality: ${formData.speciality}
// `);

            if (formData.confirmPassword === formData.password) {
                const userCredential = await createUserWithEmailAndPassword(scribeAuth, formData.email, formData.password);
                // console.log("userCredential.user: ", userCredential.user);
                // console.log("Signup successful! Welcome, " + userCredential.user.email);
    
                // console.log("userCredential: ", userCredential);
    
                await setUserDoc2(userCredential.user);
                
                toast.success("Signup successful!", {
                    className: "font-semibold"
                });

                // Open a new site in a new tab
                window.open(REDIRECT_URLS.APP_URL, "_blank");                
            } else {
                // console.warn("Passwords don't match");

                toast.warn("Passwords don't match", {
                    className: "font-semibold"
                });
                
                throw new Error("Passwords don't match");
            }

        } catch (error) {
            // console.error("Error signing up: ", error);

            toast.error("Error signing up...", {
                className: "font-semibold"
            });
        } finally {
            setFormData({
                firstName: "",
                lastName: "",
                date: "",
                email: "",
                password: "",
                confirmPassword: "",
                practiceName: "",
                speciality: ""
            });
        }
    };
    
    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return(
        <>
            <section
                id="popup-overlay"
                className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center w-full z-50"
            >
                <div className="bg-white rounded-3xl shadow-lg p-8 w-4/5 md:w-full max-w-2xl animate-slideInFromLeft_F2 md:animate-slideInFromAbove_F max-h-[80vh] overflow-auto md:max-h-full">
                    <h2 className="text-3xl font-bold text-center">Sign Up</h2>
                    <hr className="w-full my-4 border-t border-gray-100" />
                    <form onSubmit={handleSignUp} className="space-y-4">
                        {/* First Name and Last Name Row */}
                        <div className="flex flex-col md:flex-row gap-4">
                            <div className="flex-1">
                                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                                    First Name
                                </label>
                                <input
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-700"
                                    placeholder="* First Name"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="flex-1">
                                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                                    Last Name
                                </label>
                                <input
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-700"
                                    placeholder="* Last Name"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        {/* Email Field */}
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-700"
                                placeholder="* Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Password and confirm password */}
                        <div className="flex flex-col md:flex-row gap-4">
                            <div className="flex-1">
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                    Password
                                </label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-700"
                                    placeholder="* Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="flex-1">
                                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                                    Confirm Password
                                </label>
                                <input
                                    type="password"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-700"
                                    placeholder="* Confirm Password"
                                    required
                                />
                            </div>
                        </div>

                        {/* Practice Name and Medical Speciality */}
                        <div className="flex flex-col md:flex-row gap-4">
                            <div className="flex-1">
                                <label htmlFor="practiceName" className="block text-sm font-medium text-gray-700">
                                    Practice Name
                                </label>
                                <input
                                    type="text"
                                    id="practiceName"
                                    name="practiceName"
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-700"
                                    placeholder="* Practice Name"
                                    value={formData.practiceName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="flex-1">
                                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                                    Medical Speciality
                                </label>
                                <select
                                    id="medicalSpeciality"
                                    name="speciality"
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-700"
                                    value={formData.speciality}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select a speciality</option>
                                    <option value="Addiction Medicine">Addiction Medicine</option>
                                    <option value="Behavioral Health">Behavioral Health</option>
                                    <option value="Cardiology">Cardiology</option>
                                    <option value="Chiropractor">Chiropractor</option>
                                    <option value="Counseling">Counseling</option>
                                    <option value="Dentistry">Dentistry</option>
                                    <option value="Dermatology">Dermatology</option>
                                    <option value="Diagnostic Radiology">Diagnostic Radiology</option>
                                    <option value="Endocrinology">Endocrinology</option>
                                    <option value="Family Medicine">Family Medicine</option>
                                    <option value="Gastroenterology">Gastroenterology</option>
                                    <option value="Hematology">Hematology</option>
                                    <option value="Hospice and Palliative Medicine">Hospice and Palliative Medicine</option>
                                    <option value="Infectious Disease">Infectious Disease</option>
                                    <option value="Internal Medicine">Internal Medicine</option>
                                    <option value="Occupational Therapy">Occupational Therapy</option>
                                    <option value="Oncology">Oncology</option>
                                    <option value="Ophthalmology">Ophthalmology</option>
                                    <option value="Orthopedic Surgery">Orthopedic Surgery</option>
                                    <option value="Otolaryngology-Head and Neck Surgery">Otolaryngology-Head and Neck Surgery</option>
                                    <option value="Pain Medicine">Pain Medicine</option>
                                    <option value="Pediatrics">Pediatrics</option>
                                    <option value="Physical Medicine and Rehabilitation">Physical Medicine and Rehabilitation</option>
                                    <option value="Physical Therapy">Physical Therapy</option>
                                    <option value="Physician Assistant">Physician Assistant</option>
                                    <option value="Plastic Surgery">Plastic Surgery</option>
                                    <option value="Podiatry">Podiatry</option>
                                    <option value="Preventive Medicine">Preventive Medicine</option>
                                    <option value="Psychiatry">Psychiatry</option>
                                    <option value="Psychology">Psychology</option>
                                    <option value="Pulmonology">Pulmonology</option>
                                    <option value="Radiation Oncology">Radiation Oncology</option>
                                    <option value="Rheumatology">Rheumatology</option>
                                    <option value="Sleep Medicine">Sleep Medicine</option>
                                    <option value="Speech Language Pathology">Speech Language Pathology</option>
                                    <option value="Sports Medicine">Sports Medicine</option>
                                    <option value="Therapy">Therapy</option>
                                    <option value="Thoracic Surgery">Thoracic Surgery</option>
                                    <option value="Urgent Care">Urgent Care</option>
                                    <option value="Urology">Urology</option>
                                </select>
                            </div>
                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            className="w-full bg-red-700 text-white font-semibold py-2 rounded-md hover:bg-red-800 transition"
                        >
                            Sign Up
                        </button>
                    </form>

                    <div className="space-y-4">
                        {/* OR divider */}
                        <div className="flex items-center my-4">
                            <hr className="flex-grow border-t border-gray-300" />
                            <span className="px-2 text-sm text-gray-500">OR</span>
                            <hr className="flex-grow border-t border-gray-300" />
                        </div>

                        {/* Additional Sign Up Options */}
                        <div className="flex gap-4">
                            <button
                                onClick={handleGoogleSignIn}
                                type="button"
                                className="flex-1 bg-blue-600 text-white font-semibold py-2 rounded-md hover:bg-blue-700 transition"
                            >
                                Sign Up with Google
                            </button>
                            <button
                                type="button"
                                className="flex-1 bg-gray-800 text-white font-semibold py-2 rounded-md hover:bg-gray-900 transition"
                            >
                                Sign Up with Your EMR
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default SignUpPopUp2;
